// "cf" is the signup.cf.pineapple.net.au staging environment for the
// CF/sequoia integration: a prod-like build that talks to prod backends.
const prodLike = process.env.REACT_APP_ENV === "production" || process.env.REACT_APP_ENV === "cf";

export const backendURL = prodLike
  ? "https://backend.support.prod.dgtek.link"
  : "https://backend.support.master.dgtek.link";

// Sequoia (DGtek service qualification API) — G-NAF address autocomplete:
// GET `${sequoiaURL}/addresses/autocomplete?q=...` with
// `Authorization: Bearer ${sequoiaToken}`.
// The token is a public, referrer-restricted API key (same model as a
// Google Maps browser key): sequoia only accepts it from the allowlisted
// signup origins, so it is safe to ship in the bundle.
export const sequoiaURL = prodLike
  ? "https://api.public.dgtek.net"
  : "https://api.public.master.dgtek.net";

export const sequoiaToken = "1a0fb0050902971ed2c1e30c724e933589e6c8863c90af2191ee52f171f37439";

export const arrivyBookingID: { [key: string]: string } = {
  VIC: "ahRzfnRyYWNraW5nLWFwaS1tdWhpb3ItCxIMVXNlclNoYWRvdzIzGICA4MWSsMAJDAsSB0Jvb2tpbmcYgIDg1cCHsAsM",
  NSW: "ahRzfnRyYWNraW5nLWFwaS1tdWhpb3ItCxIMVXNlclNoYWRvdzIzGICA4MWSsMAJDAsSB0Jvb2tpbmcYgICQmb2KmAgM",
  QLD: "ahRzfnRyYWNraW5nLWFwaS1tdWhpb3ItCxIMVXNlclNoYWRvdzIzGICA4MWSsMAJDAsSB0Jvb2tpbmcYgICQkdeuiAsM",
};
